import moment from "moment";
import React, { useMemo} from "react";
import { calculateRoundedValue, convertCurrency, convertPriceWithCommission, imageRender, numberFormat, thousandSeperate } from "../../../helpers";

const OrderGroupDetail = ({ orderData, setSecondStep, taxPrice, shopRate, isPaymented }) => {
  const rate = useMemo(() => {
    if (shopRate) {
      return shopRate;
    }
    return {}
  }, [shopRate]);
  console.log(orderData);
  const sumPriceTotal = useMemo(() => {
    const _taxPrice = parseFloat(taxPrice || 0);
    const kip = parseFloat(orderData?.totalPrice || 0);
    const rateBath = rate?.baht || 0;
    const rateUsd = rate?.usd || 0;
    const baht = parseFloat(orderData?.sumPriceBaht || 0) * parseFloat(rateBath || 0);
    const usd = parseFloat(orderData?.sumPriceUsd || 0) * parseFloat(rateUsd || 0);

    let sumPrice = parseFloat(kip + baht + usd + _taxPrice).toFixed(2);
    if (sumPrice < parseFloat(orderData?.sumPrice || 0)) {
      sumPrice = parseFloat(orderData?.sumPrice || 0)
    }
    return calculateRoundedValue(sumPrice / 1000) * 1000
  }, [orderData, rate, taxPrice]);

  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center', borderBottom: '1px dashed #777', marginBottom: 30 }}>
      {/* <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
          <div style={{ fontWeight: 'bold', marginRight: 5 }}>{"ລາຍລະອຽດສັ່ງຊື້"}</div>
          <div>{orderData?.code}</div>
        </div> */}
      <div style={{ width: '100%', margin: '10px 0px', background: '#FFF', borderBottom: '1px dashed #777' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>
          {isPaymented ? (
            <h5>ສະບາຍດີ {orderData?.customerName ?? orderData?.cfName}</h5>
          ) : (
            TextBlinking("ລົບກວນ ທ່ານລູກຄ້າຊຳລະອໍເດີ້ນີ້", "orange")
          )}
          {/* <div style={{ fontSize: 18, fontWeight: 'bold' }}>{orderData?.customerName ?? orderData?.cfName}</div> */}
        </div>
        <div style={{ width: '100%', height: 0.2, margin: "5px 0px", background: "#EEE" }} />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ opacity: 0.7 }}>ອໍເດີ</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: ["READY_TO_SHIPPING", "SHIPPING", "SHIPPING_COMPLETED", "USERCONFIRM", "COMPLETED"].includes(orderData?.status) ? 'green' : 'red'
            }} />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ opacity: 0.7 }}>ສະຖານະ</div>
          <div style={{ fontSize: 14, fontWeight: 'bold', color: isPaymented ? 'green' : 'red' }}>{isPaymented ? "ຈ່າຍເງິນແລ້ວ" : "ຍັງບໍ່ຈ່າຍເງິນ"}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ opacity: 0.7 }}>ເລກທີບິນ</div>
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{orderData?.code}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ opacity: 0.7 }}>ວັນທີ່ສັ່ງຊື້</div>
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{moment(orderData?.createdAt).format('DD/MM/YYYY HH:mm')}</div>
        </div>
      </div>
      <div style={{ fontWeight: 'bold', width: '100%', textAlign: 'left', fontSize: 18, opacity: 0.7 }}>ລາຍການສິນຄ້າ</div>
      <div style={{ width: '100%', padding: 10, background: '#FFF', paddingBottom: 10, borderBottom: '1px dashed #777' }}>
        {
          orderData?.orders?.map((order, index) => {
            return <div key={index}>
              <div style={{ display: 'flex', width: '100%' }}>
                <img src={imageRender(order?.liveStock?.stock?.image[0] ?? (order?.postStock?.stock?.image[0] ?? order?.stock?.image[0]))}
                  style={{ maxWidth: 60, maxHeight: 60, marginTop: 10, marginRight: 10, height: "auto", borderRadius: 5 }} />
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, width:'100%' }}>
                  <p style={{ fontWeight: 'bold' }}>{order?.productName}{order?.cfMessage ? ` (${order?.cfMessage})` : ""}</p>
                  <div className="d-flex justify-content-between align-items-end w-100" style={{marginTop: '-1em'}}>
                    <p>{thousandSeperate(order?.price) + " " + order?.currency + " x" + order?.amount}</p>
                    <p>{thousandSeperate(order?.price * order?.amount ?? 0)} {convertCurrency(order?.currency)}</p>
                  </div>
                </div>
              </div>
              {/* <div style={{ width: '100%', margin: '5px 0px', height: 0.2, margin: "5px 0px", background: "#EEE" }} /> */}
            </div>
          })
        }
      </div>
      <div style={{ fontWeight: 'bold', width: '100%', textAlign: 'left', fontSize: 18, opacity: 0.7, paddingLeft: 3 }}>ຍອດລວມທັງໝົດ</div>

      <div style={{ width: '100%', padding: 10, background: '#FFF' }}>
        {/* <div style={{ display: 'flex', justifyContent: 'space-between', }}>
          <div style={{ opacity: 0.7 }}>ຈຳນວນ</div>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>{thousandSeperate(orderData?.amount)}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', }}>
          <div style={{ opacity: 0.7 }}>ລວມເປັນເງິນ (ກີບ)</div>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>{thousandSeperate(orderData?.totalPrice)}</div>
        </div> */}

        {orderData?.totalPrice > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', }}>
          <div style={{ opacity: 0.7 }}>ລວມເງິນກີບ</div>
          <div style={{ opacity: 0.7 }}>₭{thousandSeperate(orderData?.totalPrice)}</div>
        </div>
        }
        {orderData?.sumPriceBaht > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', }}>
          {/* <div style={{ opacity: 0.7 }}>ລວມເງິນບາດ {rate?.baht && `(ເລດ: ${rate?.baht})`}</div> */}
          <div style={{ opacity: 0.7 }}>ລວມເງິນບາດ</div>
          <div style={{ opacity: 0.7 }}>฿{thousandSeperate(orderData?.sumPriceBaht)}</div>
        </div>
        }
        {orderData?.sumPriceUsd > 0 &&
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* <div style={{ opacity: 0.7 }}>ລວມເງິນໂດລາ {rate?.usd && `(ເລດ: ${rate?.usd})`}</div> */}
            <div style={{ opacity: 0.7 }}>ລວມເງິນໂດລາ</div>
            <div style={{ opacity: 0.7 }}>${thousandSeperate(orderData?.sumPriceUsd)}</div>
          </div>
        }
        {/* <hr /> */}
        {
          taxPrice > 0 &&
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
              <div style={{ opacity: 0.7 }}>ຄ່າບໍລິການ</div>
              <div style={{ opacity: 0.7 }}>₭{numberFormat(taxPrice ?? 0)}</div>
            </div>
        }
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: 20, fontWeight: 'bold' }}>ເງິນທີ່ຕ້ອງຊຳລະຕົວຈິງ</div>
          {/* <div style={{ fontWeight: 'bold', fontSize: 20 }}>{numberFormat(convertPriceWithCommission(orderData?.totalPrice, orderData?.sumPriceBaht, orderData?.sumPriceUsd, taxPrice, shopRate))}₭</div> */}
          <div style={{ fontWeight: 'bold', fontSize: 20 }}>{numberFormat(sumPriceTotal)}₭</div>
        </div>
      </div>

    </div>
  );
};

function TextBlinking(text, textColor) {
  return (
    <div style={{ textAlign: 'center', marginTop: 5 }}>
      <p 
        className="blinking-text"
        style={{ 
          color: textColor || 'green', 
          fontWeight: 'bold', 
          fontSize: 16,
          display: 'inline-block',
          padding: '8px 15px',
          borderRadius: '5px',
          background: '#e8f5e9'
        }}
      >
        {text ||" ຈ່າຍເງິນແລ້ວ"}
      </p>
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes blinking {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
        .blinking-text {
          animation: blinking 1.5s infinite;
        }
      `}} />
    </div>
  );
}

export default OrderGroupDetail;
